import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { getLegalDocument, legalDocuments } from '../data/legal';
import { PageHero } from '../components/PageHero';
export function Legal() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const activeSlug = slug ?? 'privacy-policy';
  const document = getLegalDocument(activeSlug);
  if (!document) {
    return <main data-id="element-326" data-mp="a0ne8e6j2jqj">
        <PageHero breadcrumb="Legal" eyebrow="LEGAL" title="This page could not be found" description="The document you are looking for may have moved. Our privacy policy, terms of use and disclaimer are listed below." data-id="element-327" data-mp="a03xv1wj03em" />
        <section className="bg-white" data-id="element-328" data-mp="51u1wp2z8yry">
          <div className="mx-auto max-w-shell px-6 py-24" data-id="element-329" data-mp="52ve4wvqbrb9">
            <ul className="divide-y divide-slate-200 border-y border-slate-200" data-id="element-330" data-mp="3n7ynitsqaphh">
              {legalDocuments.map(item => <li key={item.slug} data-id="element-331" data-mp="3s6s26pjr4mj8">
                  <Link to={`/legal/${item.slug}`} className="flex items-center justify-between gap-4 py-5 text-[17px] text-ink/80 transition-colors duration-150 ease-out hover:text-navy-900" data-id="element-332" data-mp="27l4pf420ykf7">
                    {item.title}
                    <ArrowRightIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-333" data-mp="2hgycviha7ybr" />
                  </Link>
                </li>)}
            </ul>
          </div>
        </section>
      </main>;
  }
  return <main data-id="element-334" data-mp="1jw28xzj4mxma">
      <PageHero breadcrumb={document.title} eyebrow="LEGAL" title={document.title} description={document.intro} data-id="element-335" data-mp="1jwlj2u2jchpr" />

      <section className="bg-white" data-id="element-336" data-mp="1ym9mq1y6vsgn">
        <div className="mx-auto grid max-w-shell gap-14 px-6 py-24 lg:grid-cols-[0.3fr_0.7fr] lg:gap-20" data-id="element-337" data-mp="1ttgeh43ii1zt">
          <nav aria-label="Legal documents" className="lg:sticky lg:top-8 lg:self-start" data-id="element-338" data-mp="1633zxadrh709">
            <h2 className="text-[12px] font-medium tracking-[0.22em] text-gold" data-id="element-339" data-mp="115uc1z60t3ej">LEGAL</h2>
            <ul className="mt-5 border-t border-slate-200" data-id="element-340" data-mp="317tys6zapcvh">
              {legalDocuments.map(item => {
              const isActive = item.slug === document.slug;
              return <li key={item.slug} className="border-b border-slate-200" data-id="element-341" data-mp="3awlkvyhod2yh">
                    <Link to={`/legal/${item.slug}`} aria-current={isActive ? 'page' : undefined} className={`block py-4 text-[16px] transition-colors duration-150 ease-out ${isActive ? 'font-medium text-navy-900' : 'text-ink/70 hover:text-navy-900'}`} data-id="element-342" data-mp="3eyp8tmlj600n">
                      {item.navLabel}
                    </Link>
                  </li>;
            })}
            </ul>
            <p className="mt-8 text-[14px] leading-relaxed text-ink/60" data-id="element-343" data-mp="6inbj4rygz34">
              Questions about any of these documents can be sent through our{' '}
              <Link to="/contact" className="text-navy-900 underline decoration-gold underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-dark" data-id="element-344" data-mp="lm6omwf6bi4c">
                inquiry form
              </Link>
              .
            </p>
          </nav>

          <article className="max-w-3xl" data-id="element-345" data-mp="7tgxyeop9p0w">
            {document.sections.map(section => <section key={section.heading} className="mb-12 last:mb-0" data-id="element-346" data-mp="2wgt273l6sbd">
                <h2 className="font-serif text-[26px] leading-snug text-navy-900" data-id="element-347" data-mp="3u176kxkp9aec">
                  {section.heading}
                </h2>
                {section.paragraphs.map(paragraph => <p key={paragraph} className="mt-4 text-[17px] leading-relaxed text-ink/75" data-id="element-348" data-mp="3l1k3m7cbnwj6">
                    {paragraph}
                  </p>)}
              </section>)}
          </article>
        </div>
      </section>
    </main>;
}